<template>
    <v-autocomplete
        ref="select"
        class="filter"
        rounded
        outlined
        dense
        append-icon="mdi-chevron-down"
        v-bind="$attrs"
        v-on="$listeners"
    >
    </v-autocomplete>
</template>

<script>
export default {
    name: 'BFilterSelect',
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {
        '$attrs.value': {
            handler: _.debounce(function (val) {
                if (val && val.length) {
                    const hasNullValue = val.includes(null);
                    if (hasNullValue) {
                        return _.delay(
                            () => {
                                this.$attrs.value = null;
                            },
                            100,
                            'latter'
                        );
                    }
                }
                if (val && !val.length) {
                    return _.delay(
                        () => {
                            this.$attrs.value = null;
                        },
                        100,
                        'latter'
                    );
                }
            }),
            deep: true,
        },
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss">
.v-input.filter {
    .v-text-field__details {
        display: none;
    }
    .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
        }
    }
}
</style>
